__webpack_require__.p = "/wonjong_portfolio_react/";